/**
 * Template Engine - Rendering template con placeholder
 */

import { escapeHtml } from '../utils/format.js';

export class TemplateEngine {
  /**
   * Render template con placeholder
   * @param {string} template - Template HTML
   * @param {Object} data - Dati per placeholder
   * @returns {string} HTML renderizzato
   */
  static render(template, data) {
    let html = template;
    
    // Placeholder semplici {{key}}
    html = html.replace(/\{\{(\w+)\}\}/g, (match, key) => {
      return data[key] !== undefined ? escapeHtml(String(data[key])) : '';
    });
    
    // Blocchi condizionali {{#key}}...{{/key}}
    html = html.replace(/\{\{#(\w+)\}\}([\s\S]*?)\{\{\/\1\}\}/g, (match, key, content) => {
      return data[key] ? content : '';
    });
    
    // Rimuovi placeholder rimasti vuoti
    html = html.replace(/\{\{[#\/]?\w+\}\}/g, '');
    
    return html;
  }
  
  /**
   * Verifica se una stringa contiene placeholder
   * @param {string} str - Stringa da verificare
   * @returns {boolean} True se contiene placeholder
   */
  static hasPlaceholders(str) {
    return /\{\{\w+\}\}/.test(str);
  }
  
  /**
   * Estrai placeholder da template
   * @param {string} template - Template
   * @returns {Array<string>} Array di placeholder
   */
  static extractPlaceholders(template) {
    const matches = template.match(/\{\{(\w+)\}\}/g) || [];
    return matches.map(m => m.replace(/\{\{|\}\}/g, ''));
  }
}

